import React from 'react'
import {
  Row,
  Col,
  Breadcrumb,
  Steps,
  Divider,
  Form,
  Button,
  message,
} from 'antd'

import recruitmentsService from './../services/recruitments.service'
import fileDownloadService from './../services/file.download.service'
import ProfileContactStep from './../wizard/ProfileContactStep'
import MainExperiencePositionStep from './../wizard/MainExperiencePositionStep'
import CandidateExperienceDetailsStep from './../wizard/CandidateExperienceDetailsStep'
import SupportingDocumentsStep from './../wizard/SupportingDocumentsStep'

const { Step } = Steps

class RecruitmentsDetailView extends React.Component {
  state = {
    currentStep: 0,
    profileContactData: null,
    mainExperiencePositionData: null,
    candidateExperienceDetailsData: null,
    supportingDocumentsData: null,
    fileCV: null,
    fileCL: null,
    // fileRI: null,
  }

  componentDidMount = () => {
    const profileContactData = recruitmentsService.getProfileContactData(
      this.props.location.state[0]
    )

    const mainExperiencePositionData = recruitmentsService.getMainExperiencePositionData(
      this.props.location.state[0]
    )

    const candidateExperienceDetailsData = recruitmentsService.getCandidateExperienceDetailsData(
      this.props.location.state[0]
    )

    const supportingDocumentsData = recruitmentsService.getSupportingDocumentsData(
      this.props.location.state[0]
    )

    this.setState({
      profileContactData,
      mainExperiencePositionData,
      candidateExperienceDetailsData,
      supportingDocumentsData,
      fileCV: supportingDocumentsData.fileCV,
      fileCL: supportingDocumentsData.fileCL,
      fileRI: supportingDocumentsData.fileRI,
    })
  }

  next = () => {
    if (this.state.currentStep === 3) {
      this.props.form.validateFieldsAndScroll(['file'], (err, values) => {
        if (!err) {
          const currentStep = this.state.currentStep + 1
          this.setState({ currentStep })
        }
      })
    } else {
      const currentStep = this.state.currentStep + 1
      this.setState({ currentStep })
    }
  }

  prev = () => {
    const currentStep = this.state.currentStep - 1
    this.setState({ currentStep })
  }

  handleStepsClick = step => {
    this.setState({
      currentStep: step,
    })
  }

  handleFileUploads = (file, type) => {
    this.setState({
      [type]: file,
    })
  }

  handleFileDownload = async (fileName, recruitId, fileType) => {
    await fileDownloadService.download(
      `/api/v1/recruitments/file/download?recruitId=${recruitId}&fileType=${fileType}`,
      fileName,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      }
    )
  }

  handleSubmit = e => {
    e.preventDefault()

    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        values['fileCVId'] = this.state.fileCV ? this.state.fileCV._id : null
        values['fileCLId'] = this.state.fileCL ? this.state.fileCL._id : null
        // values['fileRIId'] = this.state.fileRI ? this.state.fileRI._id : null

        console.log('Received values of form: ', values)

        const id = this.props.location.state[0]._id
        await recruitmentsService.updateRecruitment(id, values)
        message.success('Recruitment details saved!')
        this.props.history.push('/recruitments')
      } else {
        message.error('Missing required fields!')
      }
    })
  }

  render() {
    const {
      currentStep,
      profileContactData,
      mainExperiencePositionData,
      candidateExperienceDetailsData,
      supportingDocumentsData,
    } = this.state

    const steps = [
      {
        title: 'Profile & Contact Information',
        content: (
          <ProfileContactStep
            form={this.props.form}
            profileContactData={profileContactData}
          />
        ),
      },
      {
        title: 'Main Experience & Position',
        content: (
          <MainExperiencePositionStep
            form={this.props.form}
            mainExperiencePositionData={mainExperiencePositionData}
          />
        ),
      },
      {
        title: 'Candidate Experience and Details',
        content: (
          <CandidateExperienceDetailsStep
            form={this.props.form}
            candidateExperienceDetailsData={candidateExperienceDetailsData}
          />
        ),
      },
      {
        title: 'Supporting Documents',
        content: (
          <SupportingDocumentsStep
            form={this.props.form}
            supportingDocumentsData={supportingDocumentsData}
            handleFileUploads={this.handleFileUploads}
            handleFileDownload={this.handleFileDownload}
          />
        ),
      },
    ]

    const formItemLayout = {
      layout: 'horizontal',
      labelAlign: 'right',
    }

    if (!this.props.location.state) {
      return null
    }

    return (
      <section id="recruitments-detail-view">
        <Row>
          <Col span={24}>
            <Breadcrumb style={{ marginTop: '16px' }}>
              <Breadcrumb.Item>New Recruitment</Breadcrumb.Item>
            </Breadcrumb>
          </Col>

        </Row>
        <Divider style={{background: '#8080802e', margin: '12px 0 25px 0'}}/>
        <Row>
          <Col span={4}>
            <Steps direction="vertical" size="small" current={currentStep}>
              <Step
                title="Profile & Contact Information"
                onClick={() => this.handleStepsClick(0)}
              />
              <Step
                title="Main Experience & Position"
                onClick={() => this.handleStepsClick(1)}
              />
              <Step
                title="Candidate Experience and Details"
                onClick={() => this.handleStepsClick(2)}
              />
              <Step
                title="Supporting Documents"
                onClick={() => this.handleStepsClick(3)}
              />
            </Steps>
          </Col>
          <Col span={16}>
            <section id="recruitments-add-form">
              <Form {...formItemLayout} onSubmit={this.handleSubmit} >
                {steps.map(({ title, content }, i) => (
                  <div
                    key={title}
                    className={
                      i === this.state.currentStep ? 'fade-in' : 'hide'
                    }
                  >
                    {content}
                  </div>
                ))}
                <div className="steps-action">
                  {this.state.currentStep < steps.length - 1 && (
                    <Button type="primary" onClick={this.next}>
                      Next
                    </Button>
                  )}
                  {this.state.currentStep === steps.length - 1 && (
                    <Button type="primary" htmlType="submit">
                      Done
                    </Button>
                  )}
                  {this.state.currentStep > 0 && (
                    <Button style={{ marginLeft: 8 }} onClick={this.prev}>
                      Previous
                    </Button>
                  )}
                </div>
              </Form>
            </section>
          </Col>
        </Row>
      </section>
    )
  }
}

const RecruitmentsDetailForm = Form.create({})(RecruitmentsDetailView)

export default RecruitmentsDetailForm
